var _mask, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeoAltSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 38,
    viewBox: "0 0 27 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7294 21.6861C25.4656 19.4606 26.5 16.6609 26.5 13.6196C26.5 6.37089 20.6237 0.494629 13.375 0.494629C6.12626 0.494629 0.25 6.37089 0.25 13.6196C0.25 16.8788 1.43791 19.8605 3.40438 22.1554L13.4122 37.3339L23.7294 21.6861Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7294 21.6861L21.8532 20.2224C21.8144 20.2722 21.7775 20.3235 21.7428 20.3762L23.7294 21.6861ZM3.40438 22.1554L5.39102 20.8455C5.33618 20.7623 5.27616 20.6827 5.21133 20.607L3.40438 22.1554ZM13.4122 37.3339L11.4255 38.6438C11.8659 39.3116 12.6123 39.7135 13.4122 39.7135C14.2121 39.7135 14.9585 39.3116 15.3988 38.6438L13.4122 37.3339ZM24.1204 13.6196C24.1204 16.112 23.2748 18.4002 21.8532 20.2224L25.6056 23.1498C27.6564 20.521 28.8796 17.2098 28.8796 13.6196H24.1204ZM13.375 2.87423C19.3095 2.87423 24.1204 7.68511 24.1204 13.6196H28.8796C28.8796 5.05667 21.938 -1.88497 13.375 -1.88497V2.87423ZM2.6296 13.6196C2.6296 7.68511 7.44048 2.87423 13.375 2.87423V-1.88497C4.81204 -1.88497 -2.1296 5.05667 -2.1296 13.6196H2.6296ZM5.21133 20.607C3.60042 18.727 2.6296 16.2897 2.6296 13.6196H-2.1296C-2.1296 17.4678 -0.724593 20.9939 1.59742 23.7037L5.21133 20.607ZM15.3988 36.024L5.39102 20.8455L1.41774 23.4652L11.4255 38.6438L15.3988 36.024ZM21.7428 20.3762L11.4255 36.024L15.3988 38.6438L25.7161 22.9959L21.7428 20.3762Z",
    fill: "#F5F5F5",
    mask: "url(#path-1-inside-1_0_1)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.375,
    cy: 14.2268,
    r: 3.6875,
    stroke: "#F5F5F5",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoAltSvgrepoCom);
export default __webpack_public_path__ + "static/media/geo-alt-svgrepo-com.da4f374b4553e530c1f7e7c4da196448.svg";
export { ForwardRef as ReactComponent };